// extracted by mini-css-extract-plugin
export default {"toast":"XvX59x","content":"vDKZHw"};